module.exports = __webpack_public_path__ + "img/user-settings.5fc0cf8.svg";